import React from 'react'
import styled, { injectGlobal } from 'styled-components'
import Badge from 'material-ui/Badge'
import Drawer from 'material-ui/Drawer'

import { Row } from '../../../components/Grid'
import Divider from 'material-ui/Divider'

const drawerWidth = 310

injectGlobal`
  a {
    text-decoration: none;
    color: ${props => props.theme.palette.primary1Color};
  }

  a:hover {
    color: ${props => props.theme.palette.primary2Color};
  }
  a:visited {
    color: ${props => props.theme.palette.accent1Color};
  }
`

/**
 * App bar Badge style
 */
export const AppBarBadge = styled(Badge)`
  padding: 0 !important;
`

/**
 * App bar Logo style
 */
export const AppBarLogo = styled.div`
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 190px;
    cursor: pointer;
    object-fit: cover;
  }
  @media (min-width: 768px) {
    text-align: left;
    justify-content: start;
  }
`

/**
 * Drawer
 */
export const StyledMenuDrawer = styled(({ isProfileOpen, ...props }) => (
  <Drawer {...props} width={drawerWidth} />
))`
  .drawer-container {
    display: flex;
    flex-direction: column;
    ${props => props.isProfileOpen && 'z-index: 1150 !important'};
  }
`

export const StyledProfileDrawer = styled(Drawer)`
  .drawer-container {
    display: flex;
    flex-direction: column;
  }
`

export const DrawerBadge = styled(Badge)`
  padding: 0 !important;
  position: absolute !important;
  right: 15px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  span {
    position: relative !important;
  }
`

export const DivProfile = styled.div`
  /* background-color: ${props => props.theme.palette.primary1Color}; */
  background-color: ${props => props.backgrounColor};
  background: @include
    filter-gradient(
      ${props => props.theme.palette.primary1Color},
      ${props => props.theme.palette.primary2Color},
      vertical
    );
  background: @include
    background-image(
      linear-gradient(
        top,
        ${props => props.theme.palette.primary1Color} 0%,
        ${props => props.theme.palette.primary1Color} 61%,
        ${props => props.theme.palette.primary1Color} 76%
      )
    );
  color: #fff;
`
/**
|--------------------------------------------------
| Content Container
|--------------------------------------------------
*/
export const StyledContent = styled(({ marginLeft, marginRight, ...props }) => (
  <Row {...props} />
))`
  padding-top: ${props => props.theme.appBar.height}px;
  margin-left: ${props => (props.marginLeft ? drawerWidth : 0)}px;
  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
`

/**
|--------------------------------------------------
| Menu drawer Items wrap
|--------------------------------------------------
*/
export const MenuItemWrap = styled.div`
  flex: 1;
  overflow: auto;
  padding-bottom: 15px;
`

export const DrawerHeader = styled.div`
  flex: 0 0 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.palette.primaryColor};
  /* margin-bottom: ${props => props.theme.menuItem.height / 2}px; */
  img {
    width: 190px;
    cursor: pointer;
    object-fit: cover;
  }
`
export const DividerMenu = styled(Divider)`
  margin: 10px 0px !important;
  background-color: #e5e5e5 !important;
`



// WEBPACK FOOTER //
// ./src/layouts/Authenticated/components/styled-components.js